import { supabase } from '../supabaseClient';

export const loadNormalStoreGoodsList = (start, end) => {
  return supabase
    .from('tb_store_goods')
    .select('goods_seq, store_type_cd, category_id, brand_cd, display_goods_name, discount_price, price, list1_image_url')
    .eq('store_type_cd', 'NORMAL_GOODS')
    .range(start, end)
    .order('goods_seq', { ascending: true });
};

export const normalStoreGoodsListCount = () => {
  return  supabase
  .from('tb_store_goods')
  .select('*', { count: 'exact', head: true })
  .eq('store_type_cd', 'NORMAL_GOODS');
};

export const loadDeliveryStoreGoodsList = (start, end) => {
  return supabase
    .from('tb_store_goods')
    .select('goods_seq, store_type_cd, category_id, brand_cd, display_goods_name, discount_price, price, list1_image_url')
    .eq('store_type_cd', 'DELIVERY_GOODS')
    .range(start, end)
    .order('goods_seq', { ascending: true });
};

export const deliveryStoreGoodsListCount = () => {
  return  supabase
  .from('tb_store_goods')
  .select('*', { count: 'exact', head: true })
  .eq('store_type_cd', 'DELIVERY_GOODS');
};

export const loadInterestGoodsList = async (memberSequence, start, end) => {
  return supabase
    .from('tb_store_goods_interest')
    .select(`
      goods_seq,
      tb_store_goods (
        display_goods_name,
        discount_price,
        price,
        list1_image_url
      )
    `)
    .eq('member_seq', memberSequence)
    .eq('use_yn', 'Y')
    .range(start, end)
    .order('interest_seq', { ascending: false });
};

export const loadInterestGoodsListCount = (memberSequence) => {
  return supabase
    .from('tb_store_goods_interest')
    .select('*', { count: 'exact', head: true })
    .eq('member_seq', memberSequence)
    .eq('use_yn', 'Y');
}

export const loadStoreGoodsDetail = (memberSequence) => {
    return supabase
      .from('tb_store_goods')
      .select('goods_seq, store_type_cd, category_id, brand_cd, display_goods_name, discount_price, price, list1_image_url')
      .eq('member_seq', memberSequence);
  };

export const loadStoreGoodsSearch = (keyword, start, end) => {
    return supabase
    .from('tb_store_goods')
    .select('goods_seq, display_goods_name, discount_price, price, list1_image_url')
    .like('display_goods_name', `%${keyword}%`)
    .range(start, end);
};

export const storeGoodsSearchCount = (keyword) => {
    return  supabase
    .from('tb_store_goods')
    .select('*', { count: 'exact', head: true }) 
    .like('display_goods_name', `%${keyword}%`);
};

export const autoCompleteSearch = (keyword) => {
    return supabase
    .from('tb_store_goods')
    .select('display_goods_name, goods_seq')
    .like('display_goods_name', `%${keyword}%`)
    .limit(10);
}



